import { memo } from 'react'
import Anchor from '../Anchor'
import ProfileSummary from './ProfileSummary'

type Props = {
  sectionId: string
  isStepByStepFlow?: boolean
  isFoldable?: boolean
}

const ProfileSection = (props: Props): JSX.Element => {
  const { sectionId, isStepByStepFlow, isFoldable = true } = props
  return (
    <Anchor id={sectionId} scrollOffsetTop={70}>
      <ProfileSummary isFoldable={isFoldable} isStepByStepFlow={isStepByStepFlow} />
    </Anchor>
  )
}

export default memo(ProfileSection)
